import { createRecipe } from './runtime';

const controlConfig = {"name":"control","defaultVariants":{"icon":false,"kind":"input","size":"md"},"variantMap":{"icon":["false","true"],"kind":["input","mono","select","textarea"],"size":["md","sm"]}}

export const control = /* @__PURE__ */ createRecipe(controlConfig)